import * as CONSTANTS from './actionType';

export function locationChange(data) {
    return {
        type: CONSTANTS.LOCATION_CHANGE,
        payload: data,
    };
}
